import { formatPrice } from "@stepapp/core";
import { Block, Button, SvgIcon, Typography, spacing } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { AppStorage } from "../services/AppStorage";

type Props = {
  balance: number;
  onAddPress?: () => void;
  isHeadlineVisible?: boolean;
};

const StepappWallet = ({ balance, onAddPress, isHeadlineVisible = false }: Props) => {
  const isAddBtnVisible = !!onAddPress;
  const { t } = useTranslation();
  const priceFormatter = formatPrice(AppStorage().get("countryCode"));

  return (
    <Block paddingTop={2}>
      {isHeadlineVisible && (
        <Typography variant="sectionTitle">{t("screens.payments.credits")}</Typography>
      )}

      <Block alignCenter justifySpace row marginBottom={2.5} paddingTop={2}>
        <Block alignCenter justifyCenter row>
          <SvgIcon name="wallet" size={24} />
          <Typography
            ellipsizeMode="head"
            numberOfLines={1}
            style={styles.walletText}
            variant="bodyBold"
          >
            {t("screens.payments.stepappWallet", {
              balance: isAddBtnVisible ? priceFormatter(balance) : undefined,
            })}
          </Typography>
        </Block>

        <Block row>
          {!isAddBtnVisible && (
            <Typography style={styles.walletAmount} variant="bodyBold">
              {priceFormatter(balance)}
            </Typography>
          )}

          {isAddBtnVisible && (
            <Button
              style={styles.addButton}
              label={t("common.add")}
              onPress={() => onAddPress()}
              type="link"
            />
          )}
        </Block>
      </Block>
      <Typography type="secondary" variant="lightLabel">
        {t("screens.coupons.walletFundsDescription")}
      </Typography>
    </Block>
  );
};
export default React.memo(StepappWallet);

const styles = StyleSheet.create({
  addButton: {
    marginLeft: spacing.unit * 2,
  },
  walletAmount: {
    marginTop: spacing.unit,
  },
  walletText: {
    marginLeft: spacing.unit,
    marginTop: spacing.unit,
  },
});
